import React from 'react'
import { useNavigate } from 'react-router-dom'


import HomeWorkIcon from '@mui/icons-material/HomeWork'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import FavoriteIcon from '@mui/icons-material/Favorite'

import '../style/oferta.css'

const ofertaItems = [
  { label: 'Ubezpieczenia komunikacyjne', path: '/ubezpieczenia/komunikacyjne', icon: <DirectionsCarIcon />, color: '#007BFF' },
  { label: 'Ubezpieczenia majątkowe', path: '/ubezpieczenia/majatkowe', icon: <HomeWorkIcon />, color: '#28A745' },
  { label: 'Ubezpieczenia dla branży medycznej', path: '/ubezpieczenia/dla-lekarzy', icon: <MedicalServicesIcon />, color: '#FFC107' },
  { label: 'Ubezpieczenia na życie', path: '/ubezpieczenia/na-zycie', icon: <FavoriteIcon />, color: '#C2185B' }, // ❤️ różowo-bordowy
  { label: 'Zgłoś szkodę', path: '/ubezpieczenia/zglos-szkode', icon: <ReportProblemIcon />, color: '#DC3545' }
]


export default function Oferta() {
  const navigate = useNavigate()

  return (
    <section className="oferta-container">
      <div className="oferta-text">
        <h2>Oferta</h2>
        <p>Zadbaj o swoje bezpieczeństwo z naszą szeroką ofertą ubezpieczeń.</p>
      </div>

      <div className="oferta-buttons">
        {ofertaItems.map(({ label, path, icon, color }) => (
          <button
            key={label}
            className="oferta-button"
            style={{ '--accent-color': color }}
            onClick={() => navigate(path)}
          >
            <span className="label">{label}</span>
            <span className="icon">{icon}</span>
            <span className="color-bar"></span>
          </button>
        ))}
      </div>
    </section>
  )
}
